var _circle, _circle2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHurricane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    fill: "#F8F7FF",
    stroke: "url(#paint0_linear_1062_77)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.7715,
    cy: 49.2481,
    r: 10.0723,
    fill: "#393184"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1062_77)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.8973 25.0429C41.2248 25.4665 34.3632 30.3772 31.4291 37.5445C30.5185 39.7689 30.1002 41.7729 30.0138 44.3246C29.8964 47.7932 30.5237 50.7869 31.9993 53.8001C35.0625 60.0554 41.1998 64.3078 48.1717 65.0056C48.765 65.065 49.2772 65.1402 49.31 65.1728C49.4348 65.2965 49.0885 66.7454 48.7499 67.5173C47.9454 69.351 45.8821 71.9148 44.1518 73.2311C43.9773 73.3639 43.8621 73.4999 43.8959 73.5334C43.9297 73.567 44.5624 73.7159 45.302 73.8644C47.7335 74.3526 50.7292 74.369 53.1636 73.9073C58.4514 72.9046 63.1357 69.8264 66.116 65.3958C67.7658 62.9431 68.7599 60.5188 69.3 57.6315C69.5338 56.3813 69.6213 53.3918 69.463 52.0593C68.6965 45.6075 65.1132 40.1324 59.5234 36.8716C57.2388 35.5388 54.2468 34.5422 51.7947 34.297C51.4339 34.2609 50.9232 34.2049 50.6598 34.1724L50.181 34.1133L50.244 33.5861C50.3877 32.3829 51.174 30.7194 52.3201 29.1934C52.9906 28.3008 54.6006 26.6236 55.2266 26.1655C55.471 25.9867 55.6721 25.8078 55.6735 25.7678C55.677 25.6696 54.3384 25.3744 53.0593 25.1914C51.7222 25 50.4776 24.9555 48.8973 25.0429ZM48.1866 42.1973C46.6146 42.5624 45.4273 43.2111 44.3298 44.3046C43.4564 45.1749 42.8756 46.1135 42.4775 47.2979C42.2196 48.0654 42.1861 48.3327 42.1859 49.6278C42.1857 50.9143 42.2199 51.1925 42.4694 51.9338C43.2572 54.2738 45.0846 56.0851 47.4455 56.866C48.1934 57.1133 48.474 57.1472 49.772 57.147C51.0786 57.1467 51.3484 57.1136 52.1227 56.8579C54.4765 56.0808 56.2833 54.2841 57.0745 51.9338C57.3239 51.1928 57.3582 50.914 57.3582 49.6278C57.3582 48.3417 57.3239 48.0629 57.0745 47.3219C56.0228 44.1978 53.3398 42.1994 50.0453 42.0862C49.2559 42.0591 48.6172 42.0972 48.1866 42.1973Z",
    fill: "url(#paint1_linear_1062_77)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.8973 25.0429C41.2248 25.4665 34.3632 30.3772 31.4291 37.5445C30.5185 39.7689 30.1002 41.7729 30.0138 44.3246C29.8964 47.7932 30.5237 50.7869 31.9993 53.8001C35.0625 60.0554 41.1998 64.3078 48.1717 65.0056C48.765 65.065 49.2772 65.1402 49.31 65.1728C49.4348 65.2965 49.0885 66.7454 48.7499 67.5173C47.9454 69.351 45.8821 71.9148 44.1518 73.2311C43.9773 73.3639 43.8621 73.4999 43.8959 73.5334C43.9297 73.567 44.5624 73.7159 45.302 73.8644C47.7335 74.3526 50.7292 74.369 53.1636 73.9073C58.4514 72.9046 63.1357 69.8264 66.116 65.3958C67.7658 62.9431 68.7599 60.5188 69.3 57.6315C69.5338 56.3813 69.6213 53.3918 69.463 52.0593C68.6965 45.6075 65.1132 40.1324 59.5234 36.8716C57.2388 35.5388 54.2468 34.5422 51.7947 34.297C51.4339 34.2609 50.9232 34.2049 50.6598 34.1724L50.181 34.1133L50.244 33.5861C50.3877 32.3829 51.174 30.7194 52.3201 29.1934C52.9906 28.3008 54.6006 26.6236 55.2266 26.1655C55.471 25.9867 55.6721 25.8078 55.6735 25.7678C55.677 25.6696 54.3384 25.3744 53.0593 25.1914C51.7222 25 50.4776 24.9555 48.8973 25.0429ZM48.1866 42.1973C46.6146 42.5624 45.4273 43.2111 44.3298 44.3046C43.4564 45.1749 42.8756 46.1135 42.4775 47.2979C42.2196 48.0654 42.1861 48.3327 42.1859 49.6278C42.1857 50.9143 42.2199 51.1925 42.4694 51.9338C43.2572 54.2738 45.0846 56.0851 47.4455 56.866C48.1934 57.1133 48.474 57.1472 49.772 57.147C51.0786 57.1467 51.3484 57.1136 52.1227 56.8579C54.4765 56.0808 56.2833 54.2841 57.0745 51.9338C57.3239 51.1928 57.3582 50.914 57.3582 49.6278C57.3582 48.3417 57.3239 48.0629 57.0745 47.3219C56.0228 44.1978 53.3398 42.1994 50.0453 42.0862C49.2559 42.0591 48.6172 42.0972 48.1866 42.1973Z",
    stroke: "url(#paint2_linear_1062_77)",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1062_77",
    x: 27.85,
    y: 22.85,
    width: 43.843,
    height: 53.5422,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1062_77"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1062_77",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1062_77",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DEDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1062_77",
    x1: 34.2316,
    y1: 29.5432,
    x2: 80.378,
    y2: 48.7309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0A5FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1062_77",
    x1: 53.0668,
    y1: 33.2071,
    x2: 74.2517,
    y2: 72.9019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1CDFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHurricane);
export default __webpack_public_path__ + "static/media/hurricane.6cb1b3a1310c757db33397134b16a08b.svg";
export { ForwardRef as ReactComponent };